import { Link } from "react-router-dom";
import { useFilmmakerScope } from "../context/FilmmakerScope";

export default function MainFooter() {
  const scope = useFilmmakerScope();
  return (
    <footer data-testid="main-footer" className="border-t border-gs-line bg-gs-cream mt-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-3">
            <img src="/brand/monogram.png" alt="" className="h-12 w-auto" />
            <div>
              {scope.isFilmmakerMode && scope.filmmaker ? (
                <>
                  <p className="font-display text-3xl text-gs-ink leading-none">{scope.filmmaker.name.toUpperCase()}</p>
                  <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gs-dust mt-1">on green screen pictures</p>
                </>
              ) : (
                <>
                  <p className="font-display text-3xl text-gs-ink leading-none">GREEN SCREEN</p>
                  <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gs-dust mt-1">pictures · est. 2026</p>
                </>
              )}
            </div>
          </div>
          <p className="font-serif text-lg text-gs-ink/80 mt-6 leading-relaxed">
            {scope.isFilmmakerMode && scope.filmmaker
              ? `The complete filmography of ${scope.filmmaker.name}, hosted on Green Screen Pictures — a single-screen cinema on the internet.`
              : "One screen. One story at a time. Independent cinema, released the way it was meant to be seen."}
          </p>
        </div>
        <div className="font-sans text-sm text-gs-ink/70 space-y-3">
          <p className="font-mono uppercase tracking-widest text-xs text-gs-dust">The Theater</p>
          <div className="flex flex-col gap-2">
            <Link to="/" className="hover:text-gs-ember">Now Showing</Link>
            <Link to="/about" className="hover:text-gs-ember">The Director</Link>
            <Link to="/library" className="hover:text-gs-ember">Your Library</Link>
          </div>
        </div>
        <div className="font-sans text-sm text-gs-ink/70 space-y-3">
          <p className="font-mono uppercase tracking-widest text-xs text-gs-dust">Box Office</p>
          <p>seegreenscreen.com</p>
          <p>tickets@seegreenscreen.com</p>
          <p className="text-xs text-gs-dust mt-6">© {new Date().getFullYear()} Green Screen Pictures. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
